import { useTranslation } from "react-i18next";
import IcoVheart from "../../../assets/IcoVheart";
import "./Btn_Small.css";

// const Btn_Small: React.FC = (props:Btn_SmallProps) => {
function BtnSmall(props: Btn_SmallProps) {
  const { text } = props;
  const { t } = useTranslation();
  return (
    <div
      className={`btn_small
      inline-flex
      h-16 w-full flex-1 flex-grow items-center gap-1 rounded-r-md px-3.5
      py-1 text-left font-bold text-white`}
    >
      <p className="m-0 text-[13px] uppercase leading-3">{t(text)}</p>
      <IcoVheart />
    </div>
  );
}

export default BtnSmall;

BtnSmall.defaultProps = {};

interface Btn_SmallProps {
  text: string;
}
